'use server';

import { SessionService } from '@/contexts/authentication';
import { getContentPlanRepository } from '@/contexts/content/repositories';

/**
 * Resolve the id of the in-progress content plan generating a story, if any. Lets the
 * workspace re-find the plan client-side after a refresh (the one-shot ?plan query param
 * is dropped from the URL on mount), so the generation-progress control keeps showing.
 */
export async function getActivePlanIdForStory(storyId: string): Promise<string | null> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return null;
  const task = await getContentPlanRepository().getInProgressTaskByEntityId(storyId);
  return task?.planId ?? null;
}
